import React from "react";
import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";

import { Helmet } from "react-helmet";

// Shared assets reused from Sales & Service Cloud page
import DataConsultantsIcon from "../assets/images/icons/dataConsultants.png";
import inTheMartechIndustryIcon from "../assets/images/icons/inTheMartechIndustry.png";
import expertsIcon from "../assets/images/icons/experts.png";
import topPartnersIcon from "../assets/images/icons/topPartners.png";
import MartechSMEsIcon from "../assets/images/icons/Martech-SMEs.png";
import MarketingCloudStrategyAndRoadmapIcon from "../assets/images/icons/Marketing-Cloud-Strategy-And-Roadmap.png";
import ABTestingIcon from "../assets/images/icons/ABTesting.png";
import MultiChannelJourneyOrchestrationIcon from "../assets/images/icons/Multi-Channel-Journey-Orchestration.png";
import AdvancedSegmentationAndPersonalizationIcon from "../assets/images/icons/AdvancedSegmentationAndPersonalization.png";
import ReportingAndAnalysisIcon from "../assets/images/icons/ReportingAndAnalysis.png";
import loyaltyManagementBannerMobile from "../assets/images/banner/loyaltymanagementMobile.jpg";

const LoyaltyManagement = () => {
  return (
    <>
      <Helmet>
        <title>Loyalty Management Solutions Pune | AI Customer Loyalty</title>

        <meta
          name="description"
          content="Build customer loyalty with AI-driven loyalty programs. Salesforce-based loyalty management solutions in Pune, India."
        />

        <meta
          name="keywords"
          content="Loyalty Management Pune, Customer Loyalty Programs India, AI Loyalty Solutions, Salesforce Loyalty Cloud"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Loyalty Management Solutions Pune | AI Customer Loyalty"
        />
        <meta
          property="og:description"
          content="AI-driven loyalty programs & customer retention solutions in Pune."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.comsensetechnologies.com/loyalty-management"
        />
      </Helmet>

      <header className="masthead subPageHead data-cloud-header loyaltyManagementBanner">
        <div className="container">
          <Row className="justify-content-start">
            <Col xl={7} lg={5}>
              <h1 className="masthead-heading text-white">
                Salesforce{" "}
                <span className="fancy-text4 ps-1 pe-2 mb-0  z-0 text-EE0000  position-relative overflow-hiddens text-white">
                  {" "}
                  Loyalty Management
                </span>{" "}
                Services
              </h1>
            </Col>
            <Col lg={12} className="mt-5 mt-lg-0 d-block d-lg-none">
              <Image className="w-100" src={loyaltyManagementBannerMobile} />
            </Col>
          </Row>
        </div>
      </header>

      <section className="bg-EFFDFF pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-3">
            <Col col={12}>
              <div className="text-center d-flex align-items-center justify-content-center">
                <h2 className="section-heading section-heading-center fw-700 fs-2">
                  Nurture relationships. Drive engagement. Build lasting
                  customer <span className="bordered-text">loyalty</span>{" "}
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-center justify-content-center">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="mt-0 fs-5 fw-normal ls-0">
                In today’s competitive digital economy, customer loyalty is no
                longer built on transactions alone—it is earned through
                consistent, personalized, and value-driven experiences. At{" "}
                <span className="fw-600">Comsense Technologies</span>, we help
                brands design, implement, and scale intelligent{" "}
                <span className="text-028bc6 fw-600">
                  Salesforce-powered Loyalty Management solutions
                </span>{" "}
                that turn customers into long-term advocates.
              </p>
              <p className="mt-0 fs-5 fw-normal ls-0">
                We unify customer data, engagement journeys, and rewards
                programs to deliver seamless loyalty experiences across every
                touchpoint.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section pt-80 pb-80 bg-white">
        <Container>
          <Row className="align-items-center mt-4 justify-content-center testimonials-area position-relative">
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={MartechSMEsIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">15+</h5>
                <p className="fw-500 fs-6">
                  Successful Loyalty Programs Launched
                </p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image
                    width={70}
                    className="m-auto"
                    src={DataConsultantsIcon}
                  />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">30+</h5>
                <p className="fw-500 fs-6">
                  Certified Salesforce Loyalty Specialists
                </p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image
                    width={70}
                    className="m-auto"
                    src={inTheMartechIndustryIcon}
                  />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">10+ Years</h5>
                <p className="fw-500 fs-6">
                  Experience in Customer Engagement & Retention
                </p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={expertsIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">Multi Industry</h5>
                <p className="fw-500 fs-6">Expertise</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={topPartnersIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">Top Partners</h5>
                <p className="fw-500 fs-6">
                  Salesforce Implementation & Consulting
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section pt-70 pb-70 bg-E2F1FE">
        <Container>
          <Row className="align-items-center mb-5">
            <Col col={11}>
              <div className="text-center d-flex align-items-center justify-content-center">
                <h2 className="section-heading section-heading-center fw-700 fs-2">
                  How we help you succeed with{" "}
                  <span className="bordered-text"> Loyalty Management</span>?
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-4 justify-content-start position-relative">
            <Col lg={12}>
              <Row>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4 d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MarketingCloudStrategyAndRoadmapIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Loyalty Strategy & Program Design
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        We define the right loyalty framework aligned to your
                        business objectives, customer behavior, and growth
                        goals.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ABTestingIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Member Data & Identity Unification
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        We unify customer profiles, transactions, and engagement
                        data to create a single, trusted loyalty member view.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MultiChannelJourneyOrchestrationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Points, Tiers & Rewards Management
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        We design and configure scalable earning, tiering, and
                        reward models to drive repeat engagement and retention.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={AdvancedSegmentationAndPersonalizationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Omnichannel Loyalty Activation
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Automate earn/burn rules and personalize member
                        experiences.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ReportingAndAnalysisIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Personalized Offers & Journey Orchestration
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Deliver behavior-led, real-time loyalty offers and
                        incentives using AI-powered personalization.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ReportingAndAnalysisIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Loyalty Analytics, Insights & Optimization
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Track program performance, member behavior, and ROI with
                        real-time dashboards and continuous optimization.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section bg-white pt-70 pb-70">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={10} className="offset-lg-1">
              <div className="text-center">
                <span className="d-block fw-500 ls-0 mb-1 fs-15 text-252B42">
                  Every engagement follows a simple formula
                </span>
                <h2 className="section-heading text-center mb-0 section-heading-center fw-700 fs-40">
                  We listen. We plan. We execute.{" "}
                </h2>
                <p className="text-252B42 ls-0 fw-500 fs-20">
                  Whichever engagement you choose we align with your goals,
                  craft a clear roadmap, and get it done—while guiding you
                  strategically every step of the way
                </p>
              </div>
            </Col>
          </Row>
          <Row className="align-items-stretch mt-4 justify-content-center">
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1">
                    Strategy & Program Design
                  </h3>
                  <p className="text-left mb-0 ls-0 fw-400 fs-11 flex-grow-1">
                    We assess your customer landscape, revenue goals, and
                    engagement maturity to define a high-impact loyalty strategy
                    and program framework.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="blue-box-back rounded-1  z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-blue-gradient w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 text-white">
                    Loyalty Platform Implementation
                  </h3>
                  <p className="text-left mb-0 ls-0 text-white fw-400 fs-11 flex-grow-1">
                    Deploy enterprise-grade Salesforce Loyalty Management with
                    scalable earnings, tiering, rewards, and partner
                    integrations.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1">
                    Personalization & Activation
                  </h3>
                  <p className="text-left mb-0 ls-0 fw-400 fs-11 flex-grow-1">
                    Trigger real-time, behavior-led offers and incentives across
                    marketing, commerce, mobile, and service touchpoints.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="blue-box-back rounded-1  z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-blue-gradient w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 text-white">
                    Audit, Optimization & Managed Services
                  </h3>
                  <p className="text-left mb-0 ls-0 text-white fw-400 fs-11 flex-grow-1">
                    Continuously optimize loyalty performance through
                    monitoring, analytics, enhancements, and ongoing platform
                    support.{" "}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 
      <section className="page-section bg-EFFDFF pt-80 pb-80">
        <Container>
          <Row className="align-items-start">
            <Col lg={12}>
              <h2 class="section-heading fw-700 fs-2 mb-3">
                  <span className="bordered-text bordered-text-start">
                    Loyalty
                  </span> Strategy & Program Design
                  
                </h2>
                <p className='mt-0 fs-5 fw-normal ls-0'>We help you define the right loyalty framework aligned to your business goals—points-based, tiered, subscription, coalition, or experiential programs—backed by clear KPIs and ROI models.</p>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
Salesforce Loyalty Cloud Implementation
                </h5>
                <p className="mb-3 fs-6">
End-to-end implementation of <span className='fw-600'>Salesforce Loyalty Management</span>, including:
                </p>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	Member lifecycle management
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	Points, tier, and reward configuration
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	Partner and coalition integrations
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	Real-time earning and redemption


                  </li>

                </ul>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
  Omnichannel Loyalty Experiences               </h5>
                <h6 className="fw-600 fs-6 mb-3">Deliver connected loyalty journeys across:</h6>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
 	Web and mobile
                   </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
  	POS and in-store
                    </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	Marketing and commerce platforms

                 </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	Marketing and commerce platforms

                 </li>

                </ul>
              </div>
              
            </Col>
          </Row>

          <Row className="mt-1">
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
  Personalized Engagement & Offers
                  </h5>
                <p className="mb-3 fs-6">

Leverage <span className='fw-600'>Salesforce Marketing Cloud and Data Cloud</span> to activate:

                </p>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
Behavior-based rewards
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
AI-driven next-best offers
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	Journey-triggered incentives
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
	
	Hyper-personalized campaigns at scale
                 </li>
  
                </ul>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
Partner & Affiliate Loyalty Enablement
                </h5>
                <p className="mb-3 fs-6">
 Extend loyalty beyond customers with:
                </p>
                <ul className="custom-ul mb-4 ps-0
                ">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
Channel partner incentives
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
 	Distributor reward programs
                   </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
  	Referral and affiliate models
                   </li>
                </ul>

              </div>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
  Analytics, Insights & Optimization
                  </h5>
                <p className="mb-3 fs-6">
    Gain real-time visibility into:             </p>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
              Member engagement and churn</li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
              	Program performance and ROI    </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
              	Offer effectiveness    </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
              Lifetime value growth   </li>
              
                </ul>

              </div>
            </Col>
          </Row>
        </Container>
      </section> */}

      <section className="page-section z-0 bg-EFFDFF overflow-hidden pt-70 pb-70 position-relative">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col lg={7}>
              <div className="text-center">
                <h2
                  className="text-252B42 fw-700 fs-26"
                  style={{ lineHeight: "normal" }}
                >
                  Start Your Loyalty Transformation Today
                </h2>
                <p className="text-252B42 fw-600 ls-minus036 mt-4 mb-2 fs-4">
                  Get a Salesforce Loyalty Audit / Consultation
                </p>
                <p className="ls-minus036 fs-13">
                  Assess your current loyalty strategy, uncover growth
                  opportunities, and activate high-impact, personalized reward
                  experiences across every customer touchpoint.
                </p>
                <Nav.Link
                  className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  as={Link}
                  to="../contact"
                >
                  Talk to Our Loyalty Expert
                </Nav.Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default LoyaltyManagement;
